export default "__VITE_ASSET__BoqsW_Ql__"